module.exports = __webpack_public_path__ + "img/time-bg-blue.1274a6c6.png";